import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import "./services.css";

// Videos
import v1 from "../assest/e-commorce.webm";
import v2 from "../assest/erp.webm";
import v3 from "../assest/Training.webm";
import v4 from "../assest/mobile.webm";
import v5 from "../assest/web_desing.webm";
import v6 from "../assest/mobile_pp.webm";
import v7 from "../assest/bulk_sms.webm";
import v8 from "../assest/Point of Sale.webm";
import v9 from "../assest/Retentio.webm";

// Images
import img1 from "../assest/logo/html.png";
import img2 from "../assest/logo/css.png";
import img3 from "../assest/logo/js.png";
import img4 from "../assest/logo/jquery.png";
import img5 from "../assest/logo/php.png";
import img6 from "../assest/logo/sql.png";
import img7 from "../assest/logo/koha.png";
import img8 from "../assest/servies.jpg";
import img9 from "../assest/koha.png";

function Services() {
  

  return (
    <div className="services-main">

      {/* ===================== BANNER ===================== */}
      <div className="about-banner">
        <img src={img8} alt="banner" className="banner-img" />
        <div className="banner-text">
          <h1>Our Services</h1>
        </div>
      </div>
      <div className="body-container">
        <div className="bg-blobs"></div>
        <div className="bg-blobs2"></div>
        <div className="floating-dots"></div>
      {/* Service Sections */}
      
        <div className="card-video">
          <div className="row">
            <div className="col-md-7">
              <h3 className="about-title">Website Designing</h3>
              <p>A perception: It's pretty easy now a days to design a website, our customer often ask us, Why are you charging so high or what different skills you have?</p>
              <p>Website is the face of your business and services that you provide. A well designed website is the necessity to ensure perfect delivery of your services. Our trained and experienced website design experts create websites with good soul (SEO) & healthy body (great designs).</p>
              <p>Well it's all about making that design work for your brand, At Click Informatics our designers make sure you get the design which is in your mind. Our designers ensure that your online solution working across all platforms and its helping you to gain more sales.</p>
            </div>
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v5} autoPlay loop muted className="card-video"/>
              </div>
            </div>
          </div>
        </div>

        
        <div className="card-video">
          <div className="row">
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v2} autoPlay loop muted className="card-video"/>
              </div>
            </div>
            <div className="col-md-7">
            <h3 className="about-title">Customized ERP'S</h3>
              <p>We do not provide any ready made solution for your ERP needs. As we believe that every business and their process is unique no one software can fit all needs. We have more 28 customized ERP's for different clients.</p>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-7">
              <h3 className="about-title">Mobile App Development:</h3>
              <p>Mobile app development indeed nowadays necessary for all the business. We, as a mobile application development company can provide high quality standard mobile app of any category.</p>
            </div>
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v4} autoPlay loop muted className="card-video"/>
              </div>
            </div>
          </div>
        </div>

         <div className="card-video">
          <div className="row">
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v6} autoPlay loop muted className="card-video"/>
              </div>
            </div>
            <div className="col-md-7">
            <h3 className="about-title">Custom Application Development:</h3>
              <p>We are best in this !! We can assure you let us know your custom requirement and you will be 100% satisfied with our online solution !! We have catered more than 100 different clients with different custom requirements and solved them all.</p>
              <p>Well it's all about making that design work for your brand, At Click Informatics our designers make sure you get the design which is in your mind. Our designers ensure that your online solution working across all platforms and its helping you to gain more sales.</p>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-7">
              <h3 className="about-title">E- Marketing:</h3>
              <p>Certified by Google Ad-words & Fb small agency FB marketing Program, our campaign managers make sure you get highest ROI on your marketing programs. Our E-Marketing program is divided into various stages like FB-Ads/Google Ad-words/SEO/E-Commerce Solutions.</p>
            </div>
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v1} autoPlay loop muted className="card-video"/>
              </div>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v3} autoPlay loop muted className="card-video"/>
              </div>
            </div>
            <div className="col-md-7">
              <h3 className="about-title">Training:</h3>
              <p>We specializes in PHP training and have trainers with more than 5 years of Experience and have trained 100's of B.Tech Students from IT & CS branch. We do provide live projects and applications based on PHP. Our training usually takes 45- 90 Days to finish depending on the batch/course adopted by student.</p>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-7">
              <h3 className="about-title">Bulk SMS:</h3>
              <p>Instant delivery with DND filters, we provide Bulk SMS service on priority servers. You can use these SMS's for Promotion as well as for Transactional purpose.</p>
            </div>
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v7} autoPlay loop muted className="card-video"/>
              </div>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v1} autoPlay loop muted className="card-video"/>
              </div>
            </div>
            <div className="col-md-7">
              <h3 className="about-title">E-Commerce Portal:</h3>
              <p>When it comes to eCommerce portal development, We work as partner & provide best solution for your business. We have done more 50 e commerce projects & got expertise and experience in providing best in professional solutions.</p>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-7">
              <h3 className="about-title">Retentio:</h3>
              <p>We proudly present our new product for Small & Medium Enterprises. Retentio helps you to retain your existing customers in a very small budget.</p>
              <ul>
                <li>Helps you to maintain an online profile of your client.</li>
                <li>Get interactive in regular interval</li>
                <li>Send automated wishes & reminders</li>
                <li>Increase sales through cross sales & repeat sales</li>
                <li>Most Important Keep your customer happy.</li>
              </ul>
            </div>
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v9} autoPlay loop muted className="card-video"/>
              </div>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-5">
              <div className="service-video">
                <img src= {img9}  className="card-img"/>
              </div>
            </div>
            <div className="col-md-7">
              <h3 className="about-title">Koha Library Services:</h3>
              <p>Koha is Open-Source Integrated Library Management System (ILMS) under GPL V3 or later. With a complete Web-based, Multi-lingual OPAC</p>
              <a href="">View More</a>
            </div>
          </div>
        </div>

        <div className="card-video">
          <div className="row">
            <div className="col-md-7">
              <h3 className="about-title">Point of Sale :</h3>
              <p>Find the POS system that helps you run your business by accepting payments, recording transaction data, tracking inventory and more. Here's what you need to know about fees, terms and features.</p>
            </div>
            <div className="col-md-5">
              <div className="service-video">
                <video src= {v8} autoPlay loop muted className="card-video"/>
              </div>
            </div>
          </div>
        </div>


      {/* Technologies */}
      <h2 className="tech-title">Our Technologies</h2>
      <Swiper
        slidesPerView={5}
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 1500 }}
        modules={[Autoplay]}
        className="tech-slider"
      >
        {[img1, img2, img3, img4, img5, img6, img7].map((src, i) => (
          <SwiperSlide key={i}>
            <div className="tech-card">
              <img src={src} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Testimonials */}
      <h2 className="test-title">What Clients Say</h2>
      <Swiper
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 2500 }}
        pagination={{ clickable: true }}
        modules={[Autoplay, Pagination]}
        className="testimonial-slider"
      >
        <SwiperSlide>
          <div className="testimonial-card">
            <p>"Amazing team! Our website looks modern and loads extremely fast."</p>
            <h4>— Rahul Verma</h4>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="testimonial-card">
            <p>"Best development agency. Their UI/UX skills are outstanding."</p>
            <h4>— Priya Sharma</h4>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* CTA Section */}
      <div className="cta">
        <h2>Let’s Build Something Together</h2>
        <button>Contact Us</button>
      </div>
    </div>
    </div>
  );
}

export default Services;
